import { useSelector } from 'react-redux';
import { getSortParamForMainPage } from '../ducks';

export const useGetSortParam = () => ({
  sortParam: useSelector(getSortParamForMainPage),
});
